export { default as EntExpenseSlot } from './EntExpenseSlot';
